<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入标题" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入标题" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="列表图片" prop="listImg">
        <uploadImg v-model="form.listImg" :imgSize="1" :text="['图片大小500kb以内', '图片格式png/jpg/gif']"></uploadImg>
      </el-form-item>
      <el-form-item label="是否在列表隐藏">
        <el-radio-group v-model="form.hide" @change="getHide">
          <el-radio :label="1">隐藏</el-radio>
          <el-radio :label="0">不隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="地图类型" required prop="type">
        <el-radio-group v-model="form.type" @change="changeType">
           <el-radio :label="0"  >普通</el-radio>
          <el-radio :label="1">大赛</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="参与类型" required prop="joinType">
        <el-radio-group v-model="form.joinType">
          <el-radio :label="0">免费</el-radio>
          <el-radio :label="1">其他途径</el-radio>
        </el-radio-group>
      </el-form-item>
      <div
          style="border:1px solid #DCDFE6;padding:0 0 20px 0;margin-bottom: 20px;"
          v-if="form.joinType == 1"
      >
        <div
            v-for="(item3,index3) in form.joinWaysList"
            :key="index3"
            style="margin: 0px auto;margin-top: 20px; width:98%;border:1px solid"
        >
          <div
              style="text-align: center;color: #66b1ff;width: 99%;margin: 0px auto;margin-bottom: 24px; "
          >跳转模块</div>
          <el-form-item
              label="icon"
              required
              :prop="'joinWaysList.' + index3 + '.icon'"
              :rules="[
            { required: true, message: '请上传icon', trigger: 'change' },
            ]"
          >
            <uploadImg3

                v-model="item3.icon"
                :max="1"
                :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
            ></uploadImg3>
          </el-form-item>
          <el-form-item label="跳转地址" required>
            <jumpType :Jumpurls="item3.Jumpurl"></jumpType>
          </el-form-item>
          <div style="display: flex;justify-content: center;margin-bottom:20px">
            <el-button type="primary" size="mini" @click="addjumpModal(index3)">+增加跳转模块</el-button>
            <el-button
                type="danger"
                size="mini"
                @click="removejumpModal(index3)"
                v-if="index3 !== 0"
            >-删除跳转模块</el-button>
          </div>
        </div>
      </div>
      <el-form-item label="成长币数量" required prop="creditCount" v-if="form.joinType == 1">
        <el-input-number v-model="form.creditCount" :min="0" :max="1000" label="描述文字"></el-input-number> &nbsp;
        <el-tooltip class="item" effect="dark" content="填0时将不开启成长币购买功能" placement="right-start">
          <i style="color: darkorange" class="el-icon-info"></i>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="关联活动id" v-if="form.type == 1 " required prop="activityId">
        <el-select
          class="filter-item"
          @change="selectChanged"
          v-model="form.activityId"
          placeholder="请选择大赛"
        >
          <el-option
            v-for="item in contestList"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="中心点" required>
        <el-input-number
          class="margin"
          v-model="form.centerX"
          size="mini"
          controls-position="right"
          :disabled="true"
          :min="0"
          :max="10000"
        ></el-input-number>
        <el-input-number
          v-model="form.centerY"
          class="margin"
          controls-position="right"
          size="mini"
          :disabled="true"
          :min="0"
          :max="10000"
        ></el-input-number>
        <el-button
          type="primary"
          class="margin"
          size="mini"
          @click="getUnlock"
          :disabled="unlock"
        >设置中心</el-button>
      </el-form-item>
      <!-- <el-form-item label="中心点y" prop="centerY"> -->
      <!-- <el-input v-model.number="form.centerY" placeholder="请输入中心点y" :clearable="true"></el-input> -->
      <!-- </el-form-item> -->
      <!-- <div ref="wrapper">
        <div class ref="cont"></div>
      </div>-->

      <div class="textImg">
        <el-row>
            <el-col :span="16">
                <div class="map">
                    <div class="cont" v-if="form.backgroundImg !== ''">
                        <div
                                v-if="showElements"
                                id="app"
                                :style="{width:form.width + 'px',height:form.height+'px'}"
                        >
                            <img
                                    class="images"
                                    @click="getCoordinate"
                                    :src="form.backgroundImg"
                                    ref="element"
                                    x="0"
                                    y="0"
                                    alt
                            />
                            <img
                                    class="imageT"
                                    :style="{left:(form.centerX+ 'px'),top:(form.centerY+ 'px')}"
                                    src="https://oss.lifeinmark.com/hong.png"
                            />

                            <!-- @click="getImageSize($event)" -->
                            <VueDragResize
                                    v-for="(item,index) in form.elements"
                                    :key="index"
                                    :isActive="true"
                                    :isResizable="true"
                                    :parentLimitation="false"
                                    :aspectRatio="false"
                                    :w="item.width"
                                    :h="item.height"
                                    :x="item.left"
                                    :y="item.top"
                                    :z="item.zindex"
                                    :minw="20"
                                    :minh="20"
                                    v-on:resizing="changePosition($event, index)"
                                    v-on:dragging="changePosition($event, index)"
                            >
                                <img
                                        class="imgl"
                                        :style="{width:(indesx == index ?(item.width + 'px'): (item.width+ 'px')),height:(indesx == index ?(item.height + 'px'): (item.height+ 'px'))}"
                                        :src="item.img"
                                />
                            </VueDragResize>
                        </div>
                    </div>
                    <upload-img      @change="backChanged"  v-model="form.backgroundImg" :max="1"></upload-img>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="imgitem" >
                    <div style="border:1px solid #DCDFE6;padding:0 0 20px 0;margin-bottom: 20px;">
                        <div
                                style="text-align: center;color: #66b1ff;width: 99%;margin: 0px auto;margin-bottom: 24px; "
                        >元素</div>
                        <el-collapse accordion>
                            <el-collapse-item v-for="(item, index) in form.elements" :key="index">
                <span
                        style="font-size:15px;font-weight:600; margin:20px;"
                        slot="title"
                >元素{{index + 1}}, [ 名称： {{item.name}} ]</span>
                                <el-form-item
                                        label="名称"
                                        required
                                        :prop="'elements.' + index + '.name'"
                                        :rules="[
            { required: true, message: '请填写名称', trigger: 'blur' },
            ]"
                                >
                                    <el-input v-model="item.name" placeholder="请输入名称" :clearable="true"></el-input>
                                </el-form-item>
                                <el-form-item label="层级" required :prop="'elements.' + index + '.zindex'">
                                    <el-select class="filter-item" v-model="item.zindex" placeholder="选择层级">
                                        <el-option
                                                v-for="zindexItem in zindexList"
                                                :key="zindexItem.id"
                                                :label="zindexItem.key"
                                                :value="zindexItem.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="元素类型" required :prop="'elements.' + index + '.type'">
                                    <el-radio-group v-model="item.type">
                                        <el-radio :label="0" :disabled="form.type == 1 && item.type == 1">普通</el-radio>
                                        <el-radio :label="1" :disabled="form.type == 1">任务</el-radio>
                                        <el-radio :label="2" :disabled="form.type == 1 && item.type == 1">大赛完成按钮</el-radio>
                                        <el-radio :label="3" :disabled="form.type == 1 && item.type == 1">悬浮</el-radio>
                                        <el-radio :label="4" >二级地图</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item
                                        label="图标"
                                        required
                                        :prop="'elements.' + index + '.img'"
                                        :rules="[
            { required: true, message: '请上传图标', trigger: 'change' },
            ]"
                                >
                                    <uploadImg
                                            v-model="item.img"
                                            :max="1"
                                            :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
                                            @changs="function(e){
              changs(e,index)
            }"
                                    ></uploadImg>
                                </el-form-item>
                                <el-form-item label="禁用图标">
                                    <uploadImg
                                            v-model="item.disabledImg"
                                            :imgSize="1"
                                            :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
                                    ></uploadImg>
                                </el-form-item>
                                <el-form-item label="宽" required v-if="mapHide">
                                    <el-input v-model="item.width" :clearable="true" :disabled="true"></el-input>
                                </el-form-item>
                                <el-form-item label="高" required v-if="mapHide">
                                    <el-input v-model="item.height" :clearable="true" :disabled="true"></el-input>
                                </el-form-item>
                                <el-form-item label="距左边坐标" required v-if="mapHide">
                                    <el-input v-model="item.left" :clearable="true" :disabled="true"></el-input>
                                </el-form-item>
                                <el-form-item label="距顶部坐标" required v-if="mapHide">
                                    <el-input v-model="item.top" :clearable="true" :disabled="true"></el-input>
                                </el-form-item>
                                <el-form-item label="跳转地址" required>
                                    <jumpType2 :Jumpurls="item.Jumpurl"></jumpType2>
                                </el-form-item>
                                <div style="text-align: center;margin-bottom: 10px;">
                                    <el-button type="danger" size="mini" @click="removeList(index)">删除元素</el-button>
                                    <!-- v-if="item.type == 0 || form.type == 0 || item.type == 2||item.type == 3" -->
                                </div>
                            </el-collapse-item>
                            <div style="text-align: center;margin-top: 10px;">
                                <el-button type="primary" size="mini" @click="addList()">添加元素</el-button>
                            </div>
                        </el-collapse>
                    </div>
                </div>
            </el-col>
        </el-row>

      </div>
    </el-form>
    <div class="footer" v-if="mapTrue">
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="primary" @click="getCreate('form')">确 定2</el-button>
    </div>
    <div class="footer" v-else>
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="success" @click="getModify('form')">确 定</el-button>
    </div>
  </d2-container>
</template>
<script>
import { getToken } from '@/api/demo/classification/index'
import uploadImg from '@/components/uploadImage/index.vue'
import jumpType2 from '@/components/jumpType/jumpType.vue'
import uploadImg3 from '@/components/uploadImage/index.vue'
import jumpType from '@/components/jumpType/jumpType.vue'
import VueDragResize from 'vue-drag-resize'
import { megagameList, megagameInfo } from '@/api/demo/competition/index'
import { getAddMap, getMapInfo, getMapUpdate } from '@/api/demo/map/index'
export default {
  name: 'maps',
  components: {
    VueDragResize,
    uploadImg,
    jumpType2,
    uploadImg3,
    jumpType
  },
  data () {
    return {
      // form: {
      //   cover: null //封面图
      // },
      // 七牛上传图片
      introduce: ['图片大小10M以内', '图片格式png/jpg/gif'],
      uploadUrl: 'https://up-z2.qiniup.com',
      uploadData: { key: '', token: '' },
      zindexList: [
        { id: 100, key: '底层' },
        { id: 200, key: '默认' },
        { id: 400, key: '顶层' }
      ],
      indesx: '',
      contestList: [],
      mapTrue: true,
      mapHide: false,
      mapId: '',
      mapType: '',
      unlock: false,
      form: {
        backgroundImg: '', // 背景图
        height: '', // 高
        width: '', // 宽
        name: '', // 名称
        title: '', // 标题
        // type: 0, //地图类型
        listImg: '', // 列表图片
        joinType: 0,
        creditCount: '',
        activityId: '',
        type: 1, // 元素类型
        centerX: 0,
        centerY: 0,
        elements: [],
        hide: 0,
        joinWaysList: [
          {
            icon: '', // 图标
            paramsType: '', // 参数类型
            skipType: '', // 跳转类型
            url: '', // 跳转地址
            value: '', // 参数值
            Jumpurl: {
              url: null,
              id: null,
              classId: null,
              paramType: '0',
              value: ''
            }
          }
        ]
      },
      rules: {
        title: [
          {
            required: true,
            message: '请输入标题',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }
        ]
      },
      showElements: true
    }
  },
  created () {
    let that = this
    that.mapId = this.$route.query.id
    if (that.mapId != null) {
      that.getInfo(that.mapId)
      that.mapTrue = false
    } else {
    }
    // console.log("that.mapId", that.mapId);
    getToken({}).then(res => {
      that.uploadData.token = res.token
      that.https = res.domain
    })
    that.getList()
  },
  methods: {
    getInfo (mapId) {
      let that = this
      let dataItem = []
      let taskList = []
      getMapInfo(mapId).then(res => {
        if (res.joinWaysList == null) {
          res.joinWaysList = [
            {
              icon: '', // 图标
              paramsType: '', // 参数类型
              skipType: '', // 跳转类型
              url: '', // 跳转地址
              value: '', // 参数值
              Jumpurl: {
                url: null,
                id: null,
                classId: null,
                paramType: '0',
                value: ''
              }
            }
          ]
        } else {
          res.joinWaysList.map(item => {
            item.icon = item.icon
            item.paramsType = item.paramsType
            if (parseInt(item.paramsType) == 1) {
              item.value = parseInt(item.value)
            }
            item.value = item.value
            item.url = item.url
            item.skipType = item.skipType
            item.Jumpurl = {
              url: item.url,
              id: parseInt(item.skipType),
              classId: null,
              paramType: item.paramsType,
              value: item.value
            }
          })
        }
        if (res.type == 1) {
          megagameInfo(res.activityId).then(res2 => {
            res2.clockInThemeIds.forEach(item2 => {
              taskList.push(item2)
            })
            res.elements.forEach(item1 => {
              res2.clockInThemeIds.forEach(item2 => {
                if (item1.skipValue == item2) {
                  dataItem.push(item2)
                }
              })
            })
            for (let index = 0; index < taskList.length; index++) {
              for (let index1 = 0; index1 < dataItem.length; index1++) {
                if (taskList[index] == dataItem[index1]) {
                  // console.log("taskList2", index);
                  taskList.splice(index, 1)
                }
              }
            }
            // console.log("taskList1", taskList);
            taskList.forEach(item => {
              that.form.elements.push({
                disabledImg: '', // 禁用图标
                height: 100,
                img: '', // 图标
                left: 0, // 距左边坐标
                name: '',
                top: 0, // 距顶部坐标
                width: 100,
                paramType: 6,
                skipType: 17, // 跳转类型
                skipUrl: '', // 跳转地址
                skipValue: item, // 跳转值
                type: 1, // 元素类型
                Jumpurl: {
                  url: 'pages/punch/punchDetail/index?id=' + item,
                  id: 17,
                  classId: null,
                  paramType: '6',
                  value: item
                }
              })
            })
          })
        }

        res.elements.map(item => {
          item.paramType = item.paramType
          item.skipValue = item.skipValue
          item.skipUrl = item.skipUrl
          item.skipType = item.skipType
          item.Jumpurl = {
            url: item.skipUrl,
            id: parseInt(item.skipType),
            classId: null,
            paramType: item.paramType,
            value: item.skipValue
          }
        })
        that.form = res
        console.log('that.form', that.form)
      })
    },
    // 查询列表
    getList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 100,
        keyword: '',
        classifyId: ''
      }
      megagameList(listQuery).then(res => {
        that.contestList = res.records
      })
    },
    // 七牛上传图片
    handleAvatarSuccess (res, file) {
      let that = this
      that.form.backgroundImg = that.https + '/' + res.key
    },
    uploadError (err, file) {
      this.$message({
        message: '上传出错，请重试！',
        type: 'error',
        center: true
      })
    },
    backChanged () {
      const img = new Image()
      img.src = this.form.backgroundImg

      let that = this
      setTimeout(function () {
        that.form.width = img.width
        that.form.height = img.height
      }, 1000) // 等待1秒钟后获取图片大小
    },
    // 添加元素
    addList () {
      this.form.elements.push({
        disabledImg: '', // 禁用图标
        height: 100,
        img: '', // 图标
        left: 0, // 距左边坐标
        name: '',
        top: 0, // 距顶部坐标
        width: 100,
        paramType: '',
        skipType: '', // 跳转类型
        skipUrl: '', // 跳转地址
        skipValue: '', // 跳转值
        type: 0, // 元素类型
        zindex: 200,
        Jumpurl: {
          url: '',
          id: 13,
          classId: null,
          paramType: '0',
          value: ''
        }
      })
    },
    // 删除元素
    removeList (index) {
      this.showElements = false
      this.form.elements.splice(index, 1)
      this.$nextTick(() => {
        this.showElements = true
      })
    },
    // 新增
    getCreate (forms) {
      // console.log("this.form", this.form);
      let that = this
      this.$refs[forms].validate(valid => {
        if (valid) {
          that.form.elements.forEach(items => {
            items.paramType = items.Jumpurl.paramType
            items.skipType = items.Jumpurl.id
            items.skipUrl = items.Jumpurl.url
            items.skipValue = items.Jumpurl.value
          })
          that.form.joinWaysList.map(item => {
            (item.icon = item.icon),
            (item.paramsType = item.Jumpurl.paramType),
            (item.value = item.Jumpurl.value),
            (item.skipType = item.Jumpurl.id),
            (item.url = item.Jumpurl.url)
          })
          getAddMap(that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '新增成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push('/demo/map')
          })
        }
      })
    },
    // 编辑
    getModify (forms) {
      let that = this
      this.$refs[forms].validate(valid => {
        if (valid) {
          that.form.elements.forEach(items => {
            items.paramType = items.Jumpurl.paramType
            items.skipType = items.Jumpurl.id
            items.skipUrl = items.Jumpurl.url
            items.skipValue = items.Jumpurl.value
          })
          that.form.joinWaysList.map(item => {
            (item.icon = item.icon),
            (item.paramsType = item.Jumpurl.paramType),
            (item.value = item.Jumpurl.value),
            (item.skipType = item.Jumpurl.id),
            (item.url = item.Jumpurl.url)
          })
          console.log('that.form', that.form)
          getMapUpdate(that.mapId, that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '编辑成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push('/demo/map')
          })
        }
      })
    },
    getHide (e) {
      this.form.hide = e
    },
    // 取消
    cancel () {
      let that = this
      that.$router.push('/demo/map')
    },
    deepClone (source) {
      if (typeof source !== 'object' || source == null) {
        return source
      }
      const target = Array.isArray(source) ? [] : {}
      for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          if (typeof source[key] === 'object' && source[key] !== null) {
            target[key] = this.deepClone(source[key])
          } else {
            target[key] = source[key]
          }
        }
      }
      return target
    },
    changs (e, index) {
      this.showElements = false
      let elements = this.deepClone(this.form.elements)
      elements[index].width = e.width
      elements[index].height = e.height
      this.$set(this.form.elements, index, elements[index])
      // console.log("elements1", this.form.elements);
      this.$nextTick(() => {
        this.showElements = true
      })
      // this.elements = JSON.parse(JSON.stringify(this.form.elements));
    },
    changePosition (newRect, index) {
      // console.log("--newRect", newRect, index);
      this.form.elements[index].width = newRect.width
      this.form.elements[index].height = newRect.height
      this.form.elements[index].top = newRect.top
      this.form.elements[index].left = newRect.left
      this.indesx = index
      // console.log("this.width", this.form.elements);
    },
    // 地图类型
    changeType (e) {
      let that = this
      that.mapType = e
      console.log('eeee', e)
    },
    // 选择大赛
    selectChanged (e) {
      let that = this
      let alls
      if (that.form.type == 1) {
        alls = that.form.elements.filter(item => {
          return item.type != 1
        })
        console.log(' that.form.elements', alls)
      }
      that.form.elements = alls
      megagameInfo(e).then(res => {
        console.log('ee', res.clockInThemeIds)
        res.clockInThemeIds.forEach(item => {
          that.form.elements.push({
            disabledImg: '', // 禁用图标
            height: 100,
            img: '', // 图标
            left: 0, // 距左边坐标
            name: '',
            top: 0, // 距顶部坐标
            width: 100,
            paramType: 6,
            skipType: 17, // 跳转类型
            skipUrl: '', // 跳转地址
            skipValue: item, // 跳转值
            type: 1, // 元素类型
            Jumpurl: {
              url: 'pages/punch/punchDetail/index?id=' + item,
              id: 17,
              classId: null,
              paramType: '6',
              value: item
            }
          })
        })
      })
      // console.log(e, "111");
    },
    // 解锁
    getUnlock () {
      this.unlock = true
    },
    getCoordinate (e) {
      if (this.unlock == true) {
        this.form.centerX = e.offsetX
        this.form.centerY = e.offsetY
        this.unlock = false
      }
      // console.log("getCoordinate", e.offsetX);
    },
    // 删除跳转模块
    removejumpModal (index3) {
      this.form.joinWaysList.splice(index3, 1)
    },
    // 新增跳转模块
    addjumpModal (index3) {
      this.form.joinWaysList.push({
        icon: '',
        Jumpurl: {
          url: null,
          id: null,
          classId: null,
          paramType: '0',
          value: ''
        },
        paramType: 0,
        value: '', // 参数值
        url: '', // 跳转地址
        skipType: '' // 跳转类型
      })
    }
  },
  mounted () {}
}
</script>
<style scoped>
#app {
  width: 0;
  height: 0;
  position: relative;
  overflow: hidden;
  margin: 0;
  box-sizing: border-box;
  border: 1px solid;
}
.cont {
  list-style: none;
  overflow-x: scroll;
  white-space: nowrap;
  max-width: 1100px;
}
.textImg {
  display: flex;
  justify-content: center;
}
.imgitem {
  width: 800px;
  margin-left: 60px;
}
.footer {
  text-align: center;
  margin-top: 20px;
}
.imgl {
  width: 100px;
  height: 100px;
}
/deep/ .el-collapse {
  border-bottom: 0px solid;
}
.avatar-uploader {
  display: flex;
}
/deep/.el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
.el-upload__tip {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 20px;
  margin-top: 0;
  line-height: 16px;
}
.margin {
  margin-right: 10px;
}
.imageT {
  position: absolute;
}
</style>
